module.exports = __webpack_public_path__ + "img/elf_17.f475eced.png";